import { Component } from '@angular/core';

@Component({
  selector: 'ing-type-icon',
  standalone: true,
  imports: [],
  templateUrl: './ing-type.component.html',
  styleUrl: './ing-type.component.scss'
})
export class IngTypeIcon {

}
